import $ from "jquery";

export const forumTopicFormSubmit = function () {
    $('#forumtopicform-submit, #forumtopicform-submit-external').click(function () {
        const form = $('#new-topic');

        if (form.length) {
            form[0].submit();
        }
    })
};